import React, { useRef } from 'react';
import styles from './StoryboardMenu.module.scss';
import useOutsideClick from '../../hooks/useOutsideClick';
import Menu from '../Menu/Menu';
import MenuItem from '../Menu/MenuItem';
import { useTranslation } from 'react-i18next';

const StoryboardMenu = ({ customStyles, closeStoryboardMenu, handleOpenOrientation }) => {
  const menuRef = useRef(null);

  useOutsideClick(menuRef, () => closeStoryboardMenu());

  const { t } = useTranslation();

  return (
    <Menu ref={menuRef} className={styles.menuWrapper} customStyles={customStyles}>
      {handleOpenOrientation && (
        <MenuItem
          onClick={() => {
            closeStoryboardMenu();
            handleOpenOrientation();
          }}
        >
          <span>{t('storyboard.generating.orientation')}</span>
        </MenuItem>
      )}
    </Menu>
  );
};

export default StoryboardMenu;
